import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M12.126 11.896H2c-.048 4.323 2.731 8.34 7.075 9.668.43.132.86.23 1.292.302l1.758-9.97z" }),
    React.createElement("path", { d: "M16.511 11.896l.65-3.68h4.092a9.98 9.98 0 00-6.33-5.777C9.936.915 4.676 3.48 2.745 8.216H16.51l-2.39 13.557a9.993 9.993 0 007.44-6.848 9.98 9.98 0 00.438-3.03l-5.488.001z" })));
export default createSvgIcon(iconPath, "Twinmotion");
//# sourceMappingURL=TwinmotionIcon.js.map